<template>
    <div class="post-drawer" @click.self="close">
      
        <div class="drawer">
            <!-- <img src="./Group_169.png" style="height: 100vh;position: absolute;left: 0;transform: translateX(-100%);"> -->
            <div class="drawer-header">
                <div class="container-title">
                    <p class="title">{{ $t('dash.posts.drawer.preview') }}</p>

                    <Tooltip v-if="!isProcessing"
                        :active="event.originalStatus == 'failed' && event.originalPost.page.length && event.originalPost.page[0].post_number"
                        :text="event.originalPost.page.length && event.originalPost.page[0].post_number" 
                        position='bottom'
                    >
                        <div class="badge-status" :status="event.status" :class="event.status">
                            {{ $t(`dash.post.${event.status}`)}}

                            <template v-if="!['awaiting_approval','to_validate'].includes(event.status)">
                            • {{ new Date(event.date).toLocaleDateString($i18n.locale || 'fr-FR',{ weekday: 'long', day: 'numeric', month: 'short' }) }}
                            </template>
                        </div>
                    </Tooltip>
                    <Tooltip v-else
                        :active="true"
                        :text="$t('dash.posts.drawer.processing')"
                        position='bottom'
                    >
                        <div class="badge-status" :status="event.status" :class="event.status">
                            {{ $t(`dash.post.${event.status}`)}}
                            
                            <template v-if="!['awaiting_approval','to_validate'].includes(event.status)">
                            • {{ new Date(event.date).toLocaleDateString($i18n.locale || 'fr-FR',{ weekday: 'long', day: 'numeric', month: 'short' }) }} ⚠️
                            </template>
                            <template v-else>
                            • ⚠️
                            </template>
                        </div>
                    </Tooltip>
                 

                
                 
                </div>
                <div class="close">
                    <ContextMenu 
                        :options="optionsContextMenu" 
                        :id="'drawerMoreOption'" 
                        v-on:clickOption="clickOption"
                    >
                        <i class="fa-solid fa-ellipsis-vertical more"></i>
                    </ContextMenu>

                    <i class="fa-solid fa-xmark-large"  @click="close"></i>
                </div>
            </div>
            <div class="drawer-render" :class="event.draft.tab" @mouseenter="expandedSectionNav = false">
                <div class="container-phone">
                    <div class="actions" v-if="!currentUser.role || currentUser.role.length !== 1 || currentUser.role[0] !== 'Viewer'">
                    <Tooltip 
                        v-if="['scheduled', 'draft', 'standby'].includes(this.officialStatus) && !isProcessing" 
                        :text="canUseActions ? $t('dash.posts.drawer.edit-post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="editPost"
                    >
                        <i class="fa-solid fa-pencil"></i>
                    </Tooltip>
                    <Tooltip 
                        v-else-if="
                            ['posted'].includes(this.officialStatus) && 
                            editableNetworks.includes(this.event.page.network) &&
                            this.event.draft.tab && 
                            this.event.draft.tab !== 'story' &&
                            !(this.event.page.network == 'linkedin' && haveUserMentions(event.originalPost.title))
                        " 
                        :text="canUseActions ? $t('dash.posts.drawer.update-post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="editPost"
                    >
                        <i class="fa-solid fa-pencil"></i>
                    </Tooltip>

                    
                    <Tooltip 
                        :text="canUseActions ? $t('dash.posts.drawer.duplicate-post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="duplicatePost"
                    >
                        <i class="fa-solid fa-clone"></i>
                    </Tooltip>

                    <Tooltip 
                        v-if="!isProcessing"
                        :text="$t('dash.button.delete.post')"
                        position='left'
                        @click="deletePost"
                    >
                        <i class="fa-solid fa-trash-can"></i>
                    </Tooltip>


                    </div>
                    <Phone :showNotch="event.draft.tab == 'standard'" @click="()=>indexStorySelected = (indexStorySelected+1)%Object.keys(formData.storification).length">
                       
                        <template v-if="formData && Object.keys(formData).length">
                            <div v-if="event.type && event.type == 'story'" class="drawer-container-storyMaker">
                                <div class="nav-story" v-if="Object.keys(formData.storification).length > 1">
                                     <div class="bar" v-for="(key, index) in Object.keys(formData.storification)" :class="{active: indexStorySelected == index}"></div>
                                </div>

                                <StoryMaker
                                    :formData="formData"
                                    :idStorySelected="Object.keys(formData.storification)[indexStorySelected]"
                                    :pageSelected="allPages[event.page.id]"
                                    :previewEnabled="true"
                                    :files="event.draft.files"
                                />
                            </div>
                            <RenderPostManager 
                                v-else
                                :typeNetworkSelected="event.page.network"
                                :formData="formData"
                                :files="event.draft.files"
                                :draft="draft"
                                :pages="[allPages[event.page.id]]"
                            /> 
                        </template>                  
                    </Phone>
                </div>
              
            </div>
            <div class="drawer-container-navigation" ref="scrollContainer">
                <div class="drawer-navigation" :class="{expanded: expandedSectionNav}">
                    <div class="tab" @click="expandedSectionNav = !expandedSectionNav">
                        <i class="fa-solid" :class="expandedSectionNav ? 'fa-caret-down' : 'fa-caret-up'"></i>
                        <!-- <svg width="100%" height="100%" viewBox="0 0 88 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.0883 0C8.04076 0 3.64095 3.43527 2.41674 8.33211L0.41674 16.3321C0.277115 16.8906 0.182703 17.4477 0.130859 18H85.5379C85.5021 17.6164 85.4458 17.2303 85.3683 16.8427L83.7683 8.84272C82.74 3.70106 78.2254 0 72.9819 0H13.0883Z" fill="white"/>
                        </svg> -->
                        <svg  width="100%" height="100%" viewBox="0 0 89 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.0872 2C10.0401 2 5.64066 5.43527 4.41655 10.3321L2.41672 18.3321C2.2771 18.8906 2.1827 19.4477 2.13086 20H87.5309C87.495 19.6164 87.4388 19.2303 87.3613 18.8427L85.7614 10.8427C84.7332 5.70106 80.219 2 74.9759 2H15.0872Z" fill="white"/>
                        </svg>

                    </div>
  
                    <div class="navigation">
                        <div class="item" @click="sectionNavSelected = 'comments'" :class="{active: sectionNavSelected == 'comments'}">{{ $t('dash.posts.drawer.tab.notes') }}</div>
                        <div class="item" @click="sectionNavSelected = 'assignments'" :class="{active: sectionNavSelected == 'assignments'}">{{ $t('dash.posts.drawer.tab.assignment') }}</div>
                        <div v-if="logs.length" class="item" @click="sectionNavSelected = 'logs'" :class="{active: sectionNavSelected == 'logs'}">{{ $t('dash.posts.drawer.tab.history') }}</div>
                    </div>
                    
                    <div v-if="sectionNavSelected == 'comments'" class="list-notes hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                        <div class="item input mediaMultiple">
                            <div class="container-text">
                                <div class="left">
                                    <div class="author">
                                    <div class="author-picture">
                                        <img :src="currentUser.avatar || 'img/avatar.jpg'"/>
                                    </div> 
                                    <div class="author-tect-info">
                                            <p class="name">{{ $t('dash.posts.drawer.you') }}</p>
                                            <p class="date">{{ $t('dash.posts.drawer.just-now') }}</p>
                                    </div>
                                    </div>
                                    <textarea
                                        v-model="models.commentValue"
                                        ref="textarea"
                                        rows="1"
                                        @focus="resize"
                                        @keyup="resize"
                                        :placeholder="$t('dash.posts.drawer.write-note')"
                                    ></textarea>
                                </div>
                                <div class="right">
                                    <div class="container-add-media">
                                        <label for="fileComment">
                                            <i class="fa-regular fa-paperclip"></i>
                                        </label>
                                        <input
                                            v-validate="''"
                                            name="fileComment"
                                            type="file"
                                            id="fileComment"
                                            ref="inputMediaComment"
                                            @change="selectFilesComment"
                                            :multiple="true"
                                            @click="()=>{}"
                                            :accept="'.jpg, .jpeg, .png, .pdf, .mp4, .webm, .ogg, .avi, .wmv, .flv, .mkv'" 
                                            hidden
                                        > 

                                    </div>
                                </div>
                            </div>
                            <div class="container-media" v-if="filesUploadComment.length">
                                <template v-for="(file, index) in filesUploadComment">
                                    <div class="image" v-if="file.type.startsWith('image')" @click="$delete(filesUploadComment,index)">
                                        <img :src="file.url"/>
                                    </div>
                                    <div class="video" v-else-if="file.type.startsWith('video')" @click="$delete(filesUploadComment,index)">
                                        <video :src="file.url" :type="file.type" muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </template>
                            </div>
                            <div v-if="models.commentValue.length || filesUploadComment.length" class="send" :class="{loading: this.loading.sendComment}" @click="()=>newComment()"><p>{{ $t('dash.post-creator.modal.send') }}</p></div>
                         
                        </div>

                        <div class="item" v-for="comment in comments" :class="{mediaMultiple: comment.mediasUpload.length > 1}">
                            <div class="container-text">
                                <div class="author">
                                    <div class="author-picture">
                                        <img :src="comment.avatar || 'img/avatar.jpg'"/>
                                    </div> 
                                    <div class="author-tect-info">
                                        <p class="name">{{ comment.name }}</p>
                                        <p class="date">{{ comment.dateFormat }}</p>
                                    </div>
                                </div>
                                <!-- <p class="text">{{ comment.message }}</p> -->
                                <p class="text" v-html="transformLinks(comment.message)"></p>
                            </div>
                            <div class="container-media">
                                <template v-for="media in comment.mediasUpload">
                                    <div class="image" v-if="media.type.startsWith('image')">
                                        <img :src="media.url"/>
                                    </div>
                                    <div class="video" v-else-if="media.type.startsWith('video')" >
                                        <video :src="media.url" :type="media.type" muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                   
                                  
                                </template>
                              
                            </div>
                        </div>
                    </div>
                    <div v-else-if="sectionNavSelected == 'assignments'" class="list-assignment hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                        <div class="item" v-for="user in userAffected">
                            <div class="picture">
                                <img :src="user.avatar ? user.avatar : 'img/avatar.jpg'"/>
                            </div>
                            <div class="info-text">
                                <div class="container-name">
                                    <p class="name">{{ user.firstname }} {{ user.lastname }}</p>
                                    <p class="role">{{ user.admin == true ? $t('dash.select-users.admin') : user.role && user.role.length > 0 ? $t(`dash.settings.user.${user.role[0]}`) : $t("dash.settings.user.Editor") }}</p>
                                </div>
                                <p class="email">{{ user.email }}</p>
                            </div>

                            <template v-if="!currentUser.role || currentUser.role.length !== 1 || currentUser.role[0] !== 'Viewer'">
                                <Tooltip
                                    :text="$t('dash.posts.drawer.processing')"
                                    position='left'
                                    :active="isProcessing"
                                >
                                    <div class="remove" @click="removeUserAffected(user.id)" :class="{disabled: isProcessing}">
                                        <i class="fa-solid fa-xmark-large"></i>
                                    </div>
                                </Tooltip>
                            </template>
                        </div>

                        <template v-if="validationStatus !== null">
                            <Tooltip v-if="validationStatus"
                                :text="$t('dash.posts.drawer.processing')"
                                position='top'
                                :active="isProcessing"
                            >
                                <div class="btn-primary" @click="() => removeValidationPost(null)" :class="{loading: loading.validation, disabled: isProcessing}">
                                    <p>{{ $t('dash.posts.drawer.cancel-validation') }}</p>
                                </div>
                            </Tooltip>
                            <Tooltip v-else
                                :text="$t('dash.posts.drawer.processing')"
                                position='top'
                                :active="isProcessing"
                            >
                                <div class="btn-primary" @click="()=>validatePost(null)" :class="{loading: loading.validation, disabled: isProcessing}">
                                    <p>{{ $t('dash.posts.drawer.validate-post') }}</p>
                                </div>
                            </Tooltip>
                        </template>

                        <template v-if="!currentUser.role || currentUser.role.length !== 1 || currentUser.role[0] !== 'Viewer'">
                            <Tooltip
                                :text="$t('dash.posts.drawer.processing')"
                                position='top'
                                :active="isProcessing"
                            >
                                <div @click="()=>setUsersAffected(null)" :class="{'btn-primary': validationStatus == null, 'btn-outline-primary': validationStatus !== null, loading: loading.setUserAffected, disabled: isProcessing}">
                                    <p>{{ $t('dash.select-users.assign') }}</p>
                                </div>
                            </Tooltip>
                        </template>
                      
                    </div>
                    <div v-else-if="sectionNavSelected == 'logs'" class="list-logs hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                        <div class="item" v-for="log in logs">
                            <details>
                                <summary>
                                     <div class="picture">
                                        <img :src="log.user && log.user.avatar ? log.user.avatar : 'img/avatar.jpg'"/>
                                    </div>
                                    <div class="info-text">
                                        <p class="text" v-html="log.title"></p>
                                    </div>
                                    <div class="date">
                                        <p>{{ log.dateFormat }}</p>
                                    </div>
                                </summary>
                                <div class="content" v-if="log.content" v-html="log.content"></div>
                            </details>
                           
                        </div>
                    </div>

                    
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import { EventBus } from '@/event-bus';
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import Phone from "./../../postCreator/components/Phone.vue"
    import RenderPostManager from '../../postCreator/components/standardTab/RenderPostManager.vue'
    import StoryMaker from '../../postCreator/components/storyTab/StoryMaker.vue'
    import postMixin from '@/components/mixins/Posts.vue'
    import draftMixin from '@/components/mixins/Drafts.vue'
    import postCreatorMixin from '../../postCreator/mixins/main.js'
    import postsMixin from '@/components/dash/posts/mixins/main.js'
    import CommonMixin from '@/components/mixins/Common'
    import Popup from '@/utils/Popup'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import { 
        mergeUpdates, 
        deepClone, 
    } from '../../postCreator/utils.js'
    import { editableNetworks } from '@/components/dash/postCreator/constante.js'

    import * as marked from 'marked'

    import {VueDraft} from '@mashupweb/draft-lib/'


    export default {
        mixins: [postMixin, draftMixin, postCreatorMixin, postsMixin, CommonMixin],

        components: {
            ContextMenu,
            Phone,
            RenderPostManager,
            StoryMaker,
            Tooltip
        },
        props: {
            event: Object,
        },

        data() {
            return {
                
                models: {
                    commentValue: ''
                },
                comments : [],
                filesUploadComment: [],
                userAffected : [],


                sectionNavSelected: this.validationStatus !== null ? 'assignments' : 'comments',
                expandedSectionNav: false,
                loading : {
                    sendComment: false,
                    setUserAffected: false,
                    validation: false
                },

                //Pour generateDataFormRequest
                dataFormRequest: {},
                tab: null,
                saveAllFormData: null,
                formData: null,
                idUsersAssigned: [],
                requiredValidation: false,
                logs: [],
                files: {},

                //storyMaker
                indexStorySelected: 0,

                editableNetworks,
                isRefreshingMusic: false,

                draft: null,
            }
        },

        mounted () {

            this.$refs.scrollContainer.addEventListener('wheel', this.handleScroll);
            this.sectionNavSelected = this.validationStatus !== null ? 'assignments' : 'comments';
            // Handled by watcher
            // this.setFormData()
      

            this.$gtag.event('page_view', {
                page_title: 'Test Page',
                page_location: window.location.href
            });

            try {
                this.draft = new VueDraft({
                    saveAllFormData: this.event.draft.saveAllFormData, 
                    files: this.event.draft.files,
                    pages: this.event.draft.pages.map(idOrPage => {
                        if (typeof idOrPage === 'object') return idOrPage
                        return this.allPages[idOrPage]
                    }).filter(Boolean),
                    metadata: this.event.originalPost,
                    usersAssigned: this.event.draft.usersAssigned,
                })
                this.draft.merge.run(this.event.page)

                console.log('new Draft', this.draft)

           
                console.log('new Draft', this.draft.form.textContent.value)
            } catch (error) {
                console.log("new Draft error", error)
            }
        },
        
        methods: {

            haveUserMentions(text) {
              let regexMentionsUser = /\(([0-9a-zA-Z_\-]{39})\)/g
              let mentionsUser = [...text.matchAll(regexMentionsUser)].map(e => e[1])
              return mentionsUser.length > 0
            },

            transformLinks(text) {
                if (!text) return '';

                // 1. Échapper le HTML pour éviter les injections XSS (très important !)
                const safeText = text
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#039;');

                // 2. Expression régulière pour détecter les URLs (http, https, www)
                const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

                // 3. Remplacement par des balises <a>
                return safeText.replace(urlRegex, (url) => {
                    const href = url.startsWith('http') ? url : `https://${url}`;
                    return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="link">${url}</a>`;
                });
            },

            resize() {
                const { textarea } = this.$refs;
                textarea.style.height = 0
                textarea.style.height = textarea.scrollHeight + 'px';
            },

            close() {
                this.$emit('close')
            },

            getMemoizedVerify() {
                if (!this._memoizedVerify) {
                    this._memoizedVerify = this.memoizeAsync(
                        async (key, saveAllFormData, pageId) => {
                        return await this.verifyDynamicUrlInstagram(saveAllFormData, pageId);
                        }
                    );
                }
                return this._memoizedVerify;
            },

            async setFormData(formData, verifyDynamicUrl = true) {
                console.log("setFormData", formData, this.event && this.event.draft && this.event.draft.saveAllFormData)
                if (!formData) {
                    if (!this.event?.draft?.saveAllFormData) return null
                    formData = this.event.draft.saveAllFormData
                }
               
                let formDataRef = deepClone(formData.main)
                console.log(this.event.draft.tab, ['story_share','story'].includes(this.event.draft.tab),this.event.page.network, this.event.page.network == 'facebook', formDataRef)
                if (['story_share','story'].includes(this.event.draft.tab) && this.event.page.network == 'facebook') {
                    //repoduire la storification par rapport a la page instagram d'origine
                    if (formData.networks['instagram']) mergeUpdates(formDataRef, formData.networks['instagram'])
                    const pageInstagramAtached = Object.values(this.allPages).find(p => p.network == 'instagram' && p.affected_to && p.affected_to == this.allPages[this.event.page.id].network_id)
                    if (pageInstagramAtached && formData.pages[pageInstagramAtached.id]) mergeUpdates(formDataRef, formData.pages[pageInstagramAtached.id])
                }else{
                    if (formData.networks[this.event.page.network]) mergeUpdates(formDataRef, formData.networks[this.event.page.network])
                    if (formData.pages[this.event.page.id]) mergeUpdates(formDataRef, formData.pages[this.event.page.id])
                }
            
                this.formData = formDataRef

                //mettre a jours les liens invalide
                if (verifyDynamicUrl) {
                    this.isRefreshingMusic = true;
                    const timeout = setTimeout(() => {
                        this.isRefreshingMusic = false;
                    }, 10000);
                    let pageId = this.event.page.id;
                    if (this.event.page.network !== "instagram" || !this.allPages[pageId].story_config?.created) {
                        // Find the instagram page’s id
                        pageId = null;
                        if (this.event.originalPost?.page?.[0]?.posts_multipages) {
                            for (let pm of this.event.originalPost.page[0].posts_multipages) {
                                const page = this.allPages[pm.page];
                                if (page?.network === 'instagram' && page?.story_config?.created) {
                                    pageId = page.id;
                                    break;
                                }
                            }
                        }
                        if (!pageId) {
                            // Try if in pageEmbed, in case of story share to FB
                            const fbPage = this.allPages[this.event.page.id];
                            const instaPage = Object.values(this.allPages).find((p) => p.affected_to === fbPage.network_id)
                            pageId = instaPage?.id;
                        }
                    }
                    if (pageId) {
                        const logContext = {
                            post_id: this.event.originalPost.id,
                            page_id: pageId,
                            originalStatus: this.event.originalStatus,
                        }
                        const {saveAllFormData, isModified} = await this.verifyDynamicUrlInstagram(this.event.draft.saveAllFormData, pageId);

                        // WIP Memoization required to avoid requesting 3 times because of refreshes
                        // const key = `${this.event.page.id}`
                        // const memoizedVerify = this.getMemoizedVerify();
                        // const { saveAllFormData, isModified } =
                        // await memoizedVerify(key, this.event.draft.saveAllFormData, this.event.page.id);

                        if (isModified) {
                            console.log("Music refreshed")
                            this.addLog(this.currentUser, 'music-refresh-success', { logContext, draft: this.event.draft })
                            this.setFormData(saveAllFormData, false)
                        }
                    }
                    clearTimeout(timeout);
                    this.isRefreshingMusic = false;
                }
                this.isRefreshingMusic = false;
            },

            editPost() {
                if (!this.canUseActions) return;
                let eventOldVersion = this.event.originalStatus == 'draft' && !this.event.originalPost.draft.data.saveAllFormData
                
                if(eventOldVersion) {
                    const baseUrl = window.location.origin;
                    const paramsLink = {
                        post_id: this.event.originalPost.id,
                        page_id: this.event.page.id,
                        bot_id: this.event.originalPost._bots[0].id,
                        is_draft: this.officialStatus === 'draft',
                        edit_post: true,
                        no_redirection: true
                    };

                    this.$router.push({
                        path: '/dash/planner',
                        query: paramsLink // Ajout des paramètres dans la query string
                    });
                    return
                }

                switch (this.officialStatus){
                    case 'standby':
                        this.$store.commit('postCreator/setDataForDraft', {
                            data: this.event.draft,
                            id : this.event.originalPost.id
                        });
                        return this.duplicatePost(this.event.originalPost.id)
                    case 'posted':
                    case 'scheduled':
                        let posts 
                        if (this.event.originalPost.page[0].posts_multipages && this.event.originalPost.page[0].posts_multipages.length) {
                            posts = this.event.originalPost.page[0].posts_multipages.filter(m => this.allPages[m.page])
                        }else{
                            posts = [{
                                _id: this.event.originalPost.id,
                                id: this.event.originalPost.id,
                                bot: this.event.originalPost._bots[0].id,
                                page: this.event.originalPost._bots[0].page.id,
                                postId: this.event.originalPost.page[0].post_number,
                                status: this.event.originalPost.status,
                            }]
                        }

                        this.$store.commit('postCreator/setDataForEditPost', {
                            instance: this.draft,
                            draft: this.event.draft,
                            posts,
                            post: this.event.originalPost

                        });
                        if (this.officialStatus == 'scheduled') this.$router.push('/dash/postCreator/edit');
                        else this.$router.push('/dash/postCreator/update');
                       
                    break;
                    case 'draft':
                        this.$store.commit('postCreator/setDataForDraft', {
                            instance: this.draft,
                            data: this.event.draft,
                            id : this.event.originalPost.id
                        });
                        this.$router.push('/dash/postCreator/draft');
                    break;
                }
                                 
            },                                                                                      

            duplicatePost(excludeNews = false) {
                if (!this.canUseActions) return;
                let pages
                if (this.event.originalStatus == 'draft' && this.event.draft.pages && this.event.draft.pages.length) {
                    pages = this.event.draft.pages
                }else if (this.event.status != 'standby' && this.event.originalPost.page[0].posts_multipages && this.event.originalPost.page[0].posts_multipages.length) {
                    pages = this.event.originalPost.page[0].posts_multipages.map(post => post.page) 
                }else{
                    pages = [this.event.originalPost._bots[0].page.id]
                }
     
                this.$store.commit('postCreator/setDataForDuplicatePost', {
                    instance: this.draft,
                    draft: this.event.draft,
                    pages,
                    excludeNews
                });
                this.$router.push('/dash/postCreator/duplicate');
            },

            deletePost() {

                EventBus.$emit("showModal",
                    this.$t('dash.button.delete.post'),
                    this.$t('dash.posts.drawer.delete-confirm'),
                    this.$t('dash.button.delete'),
                    this.$t('dash.button.cancel'),
                    ()=>{
                        this.$emit('deletePost')
                    }
                );
               
            },

            clickOption(contextMenuId, nameOption, event) {
           
                switch (nameOption) {
                    case 'copyLink':
                        const baseUrl = window.location.origin;
                        const paramsLink = {
                            post_id: this.event.originalPost.id,
                            page_id: this.event.page.id,
                            bot_id: this.event.originalPost._bots[0].id,
                            is_draft: this.officialStatus === 'draft'
                        };

                        const queryString = new URLSearchParams(paramsLink).toString();
                        // const link = `${baseUrl}/#/dash/posts2?${queryString}`;
                        let eventOldVersion = !((this.event.originalStatus == 'draft' && this.event.originalPost.draft.data.saveAllFormData) || (this.event.originalStatus != 'draft' && this.event.originalPost.page[0].draft && this.event.originalPost.page[0].draft.includes('saveAllFormData')))
                        const link = `${baseUrl}/${eventOldVersion ? '' : '#/dash/posts2'}?${queryString}${eventOldVersion ? '&show_post=true&no_redirection=true' : ''}`;

                        navigator.clipboard.writeText(link).then(() => {
                            this.$vs.notify({
                                title: this.$t('dash.posts.success'),
                                text: this.$t('dash.settings.user.viewer_url.copy'),
                                color:'success'
                            })
                           
                        }, (err) => {
                            console.error('Error copying text: ', err);
                        });
                        break;
                    case 'showPost':
                        this.showOriginalPost()
                        break;
                    default:
                        break;
                }
            },

            async showOriginalPost(){
                let url
                switch(this.event.page.network){
                    case 'facebook':
                        url = `https://www.facebook.com/${this.event.originalPost.page[0].post_number}`
                    break
                    case 'twitter': 
                        const username = this.event.originalPost._bots.find(b => b.uid == this.event.originalPost.page[0].id).page.name
                        url = `https://www.twitter.com/${username}/status/${this.event.originalPost.page[0].post_number}`
                    break
                    case 'linkedin': 
                        if (this.event.originalPost.page[0].post_number_bis) {
                            url = `https://www.linkedin.com/feed/update/${this.event.originalPost.page[0].post_number_bis}`
                        } else {
                            const res = await this.getLinkedinPost(this.event.originalPost._bots[0].page.id, this.event.originalPost.page[0].post_number)
                            const { success, post } = res.body

                            if(success && post && post.activity)
                                url = `https://www.linkedin.com/feed/update/${post.activity}`
                            else if(success && post && post.id)
                                url = `https://www.linkedin.com/feed/update/${post.id}`
                        }
                    break
                    case 'pinterest':
                        url = `https://www.pinterest.fr/pin/${this.event.originalPost.page[0].post_number}`
                    break
                    case 'google':
                        if(this.event.originalPost.page[0].post_number_bis)
                            url = this.event.originalPost.page[0].post_number_bis
                        else {
                            const res = await this.getGooglePost(this.event.originalPost._bots[0].page.id, this.event.originalPost.page[0].post_number)
                            const { success, searchUrl } = res.body
                            if(success && searchUrl) url = searchUrl
                            else url = `https://www.google.com/search?q=${this.event.originalPost.page[0].post_number}`
                        }
                    break
                    case 'youtube':
                        url = `https://www.youtube.com/shorts/${this.event.originalPost.page[0].post_number}`
                        //redirection vers la vidéo si pas format reel par youtube
                    break
                    case 'threads':
                        const threadsUsername = this.event.originalPost._bots.find(b => b.uid == this.event.originalPost.page[0].id).page.name
                        url = `https://www.threads.net/@${threadsUsername}`
                    break
                    case 'bluesky':
                        const blueskyUsername = this.event.originalPost._bots.find(b => b.uid == this.event.originalPost.page[0].id).page.name
                        url = `https://bsky.app/profile/${blueskyUsername}/post/${this.event.originalPost.page[0].post_number.split('/').pop()}`
                    break
                    default:
                }

               if (url) Popup.open(url, '', 900, 700)
            },

            formatDateRelative(d) {
                if (typeof d !== "object") d = new Date(d)
                const now = new Date()
                const locale = this.$i18n.locale || 'fr-FR'
                const hhmm = d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
                const sameDay = d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()
                const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1)
                const isYesterday = d.getDate() === yesterday.getDate() && d.getMonth() === yesterday.getMonth() && d.getFullYear() === yesterday.getFullYear()
                if (sameDay) return this.$t('dash.posts.drawer.today-at') + ' ' + hhmm
                if (isYesterday) return this.$t('dash.posts.drawer.yesterday-at') + ' ' + hhmm
                const dateStr = d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
                return this.$t('dash.posts.drawer.date-prefix') + ' ' + dateStr + ' ' + this.$t('dash.posts.drawer.date-at') + ' ' + hhmm
            },

            dateFormat(dateFormat) {
                return this.formatDateRelative(dateFormat)
            },

            buildComment() {
        
                if (this.event.originalPost.page.length && this.event.originalPost.page[0].comments && this.event.originalPost.page[0].comments.length) {
                    this.comments = this.event.originalPost.page[0].comments.map((comment) => ({
                        ...comment,
                        dateFormat : this.dateFormat(comment.date),
                        avatar:  this.usersSortByEmail[comment.email] ? this.usersSortByEmail[comment.email].avatar : null,
                        ...(comment.email == this.currentUser.email ? {name : this.$t('dash.posts.drawer.you')} : {})
                    })).reverse()
                }else{
                    this.comments = []
                }
            },

            buildAssignment() {
                console.log("buildAssignment")
                this.userAffected = []
                if (this.event.originalPost.page.length && this.event.originalPost.page[0].affectedTo) {
                    if (this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.length) {
                        this.userAffected = this.event.originalPost.page[0].affectedTo.users
                    }else if(this.event.originalPost.page[0].affectedTo.user){
                        this.userAffected = [this.event.originalPost.page[0].affectedTo.user]
                    }
                }
                this.userAffected = this.userAffected.map((user) => ({
                    ...user,
                    ...(this.$store.getters['users/getUsers'][user.id] || {}),
                }))
            },

            buildLogs() {
                console.log("buildLogs")
                const dateFormatPost = (dateLog) => {
                    if (Date.now() - new Date(dateLog).getTime() < 60000) {
                        return this.$t('dash.posts.drawer.just-now')
                    }
                    return this.formatDateRelative(dateLog)
                }

                
                if (this.event.originalPost && this.event.originalPost.page && this.event.originalPost.page[0] && this.event.originalPost.page[0].log) {
                    console.log("buildLogs", this.event.originalPost.page[0].log)
                    this.logs = this.event.originalPost.page[0].log.reduce((acc, log) => {
                                           
                        try {
                            if (typeof log == 'string') log = JSON.parse(log)
                            console.log("log", log)
                            if (!('title' in log) || !('created_at' in log) || !('user' in log)) return acc
                        
                            if (log.title.startsWith('dash.')) {
                                const parts = log.title.split('|')
                                const key = parts[0]
                                const params = parts[1] ? JSON.parse(parts[1]) : {}
                                log.title = this.$t(key, params)
                            }

                            if (log.user.lastname && log.user.firstname) {
                                log.title = log.title.replace('$name', `<span class="name">${log.user.lastname} ${log.user.firstname}</span>`)
                            }else {
                                log.title = log.title.replace('$name', `<span class="email">${log.user.email}</span>`)
                            }
                        

                            acc.push({
                                ...log,
                                content: log.content ?  marked.parse(log.content) : '',
                                dateFormat: dateFormatPost(log.created_at)
                            });
                        } catch (error) {
                            console.error("Error parsing log", error)
                        }
                        
                        
                        return acc;
                    }, []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Trier par date décroissante
                }else{
                    console.log('aucunes logs disponibles')
                }
            },

            handleScroll(event) {
                this.expandedSectionNav = true
                // if (event.deltaY > 0) {
                //     this.expandedSectionNav = true
                // }
            },

            selectFilesComment(e) {
                const files = Array.from(e.target.files);
                this.filesUploadComment = files.map((file, index) => {

                    return {
                        url: URL.createObjectURL(file),
                        type: file.type
                    }
                })
            },

            async newComment(all=null) {
                if (this.loading.sendComment) return

                if (all == null) {
                    if (this.isPostsMultipaged(this.event.originalPost)) {
                        EventBus.$emit("showModal",
                            this.$t('dash.posts.multi-pages.add_note.title'),
                            this.$t('dash.posts.multi-pages.add_note.body'),
                            this.$t('dash.posts.drawer.all-posts'),
                            this.$t('dash.posts.drawer.this-post-only'),
                            ()=>{
                                this.newComment(true)
                            },
                            ()=>{
                                this.newComment(false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }
            
                this.$set(this.loading, 'sendComment', true)
                let mediasUpload = []

                for (const file of this.filesUploadComment) {
                    const {file_url} = await this.uploadFile(file.url);
                    mediasUpload.push({
                        url: file_url,
                        type: file.type
                    })
                    console.log("newComment res", file_url)
                }

                const comment = {   
                    date: new Date().toISOString(),
                    message: this.models.commentValue,
                    name: !localStorage.supervisor ? `${this.currentUser.lastname} ${this.currentUser.firstname}` : 'Mashup Web Social',
                    email: !localStorage.supervisor ? this.currentUser.email : 'contact@mashup-web.com',
                    mediasUpload: mediasUpload
                }
                console.log("newComment", comment,  this.event.originalPost, all)
                try {
                    const {body} = await this.addCommentPost(
                        this.event.originalPost,
                        comment,
                        all
                    )
                    if (body.success) {
                        this.filesUploadComment = []
                        this.$set(this.models, 'commentValue', '')
                        this.$set(this.event, 'originalPost', {...this.event.originalPost, ...body.post})
                        this.buildComment()
                    }
                } catch (error) {
                    console.error(error)
                }
                this.$set(this.loading, 'sendComment', false)
            },
            
            async uploadFile(file) {
                const { VUE_APP_API_HOST } = process.env 

                if (typeof file === "string" && file.startsWith("blob:")) {
                    const response = await fetch(file);
                    const blob = await response.blob();
                    file = new File([blob], "uploaded-file", { type: blob.type });
                }

                let formData = new FormData()
                formData.append('file', file)

                try {
                    const  { body } = await this.$http.post(`${VUE_APP_API_HOST}/posts/upload/file`, formData)
                    return body
                } catch (error) {
                    
                }
            },

            async removeUserAffected(userId) {
                if (this.isProcessing) return;

                this.userAffected = this.userAffected.filter(user => user.id !== userId)
                const optionValidation = this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == true || this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == 'true'
                const idUsersSelected = this.userAffected.map(user => user.id)

                const draft = JSON.parse(JSON.stringify(this.event.draft))
                draft.idUsersAssigned = idUsersSelected
                draft.requiredValidation = optionValidation

                const data = {
                    page: this.event.originalPost._bots[0].page.id, 
                    bot: this.event.originalPost._bots[0].id, 
                    post: this.event.originalPost.id, 
                    status: this.event.originalPost.status,
                    optionValidation,
                    draft : draft
                }

                if (idUsersSelected.length) {
                    data.user= idUsersSelected[0]
                    data.users= idUsersSelected
                }
                console.log("affectedUserToPost", data)
                await this.affectedUserToPost(data)
                EventBus.$emit('planner/refresh', 1000)
            },

            async validatePost(all=null) {
                if (this.isProcessing) return;
                if (this.loading.validation) return

                if (
                    !(this.event.originalPost.page[0].affectedTo.user && this.event.originalPost.page[0].affectedTo.user.id == this.currentUser.id) &&
                    !(this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                ) {
                    return
                }

                let countPage = 1
                if (this.officialStatus == "draft")  countPage = this.event.draft.pages.length 
                else if (this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length 
                                                                                        
                
                if (all == null) {
                 
                    if (countPage > 1) {
                        EventBus.$emit("showModal",
                            this.$t('dash.posts.multi-pages.validate_post.title'),
                            this.$t('dash.posts.multi-pages.validate_scheduled.body'),
                            this.$t('dash.posts.drawer.validate-all-posts'),
                            this.$t('dash.posts.drawer.validate-this-post'),
                            ()=>{
                                this.validatePost(true)
                            },
                            ()=>{
                                this.validatePost(false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }
            
                this.$set(this.loading, 'validation', true)
                switch (this.officialStatus) {
                    case "scheduled":
                        await this.validateSchedulePost(all)
                        this.$set(this.loading, 'validation', false)
                        break;
                    case "draft":
                        setTimeout(() => {
                            EventBus.$emit("showModal", 
                                this.$t(`dash.posts.multi-pages.validate_draft_to_post${countPage > 1 ? 's' : ''}.title`),
                                this.$t(`dash.posts.multi-pages.validate_draft_to_post${countPage > 1 ? 's' : ''}.body`), 
                                this.$t('onboarding.2fa.continue'),
                                this.$t('dash.button.cancel'),
                                async ()=>{
                                    await this.validateDraft(all)
                                    this.$set(this.loading, 'validation', false)
                                },
                                ()=>{
                                    this.$set(this.loading, 'validation', false)
                                }
                            )
                        }, 200);
                   
                        break;
                }

                
            },

            async validateSchedulePost(all) {
                if (this.isProcessing) return;
                const res = await this.validateWaitingPost(this.event.originalPost, {
                    name: `${this.currentUser.firstname} ${this.currentUser.lastname}`, 
                    email: this.currentUser.email,
                    date: new Date().toISOString()
                }, all)

                this.$set(this.event, 'originalPost', {...this.event.originalPost, ...res.body.post })
                
                const newEvent = await this.buildEvent({...this.event.originalPost, ...res.body.post })
                this.$set(this.event, 'status', newEvent.status)
                this.$set(this.event, 'originalStatus', newEvent.originalStatus)
                EventBus.$emit('planner/refresh', 2000)
                
            },

            async validateDraft(all) {
                
                this.tab = this.event.draft.tab && this.event.draft.tab !== 'standard' ? 'story' : 'standard'
                this.saveAllFormData = this.event.draft.saveAllFormData
                this.idUsersAssigned = this.event.draft.idUsersAssigned
                this.requiredValidation = this.event.originalPost.page[0].affectedTo.optionValidation == true || this.event.originalPost.page[0].affectedTo.optionValidation == 'true'
                this.files = this.event.draft.files

            
                let pagesSelected = [this.allPages[this.event.page.id]]
                
                if (all) {
                    pagesSelected = this.event.draft.pages.reduce((acc, page) => {
                        if (this.allPages[page]) acc.push(this.allPages[page])
                        return acc
                    }, [])
                }
                
                if (this.tab == 'story') {
                    pagesSelected = pagesSelected.filter(page => page.network == 'instagram')
                }

                const log = this.generateLog({
                    title: 'dash.posts.log.validated-post',
                })
                
                this.generateDataFormRequest((dataFormRequest) => {
                    console.log("validateDraft", "dataFormRequest", dataFormRequest)
                    const requestGroup = []
                    for (const [pageId, formData] of Object.entries(dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.allPages[pageId]    
                            formData.log = JSON.stringify([JSON.stringify(log), ...this.event.draft.log || []])                
                            requestGroup.push({
                                start : async (onSuccess, onProgress, onError) => {
                                    try {
                                        this.$store.commit('planner/addNewStaticEvent', {
                                            eventId: this.event.originalPost.id + page.id,
                                           
                                            event: {
                                                content: formData["data[title]"],
                                                date: formData["data[scheduled_date]"] || new Date().toISOString(),
                                                id: this.event.originalPost.id + page.id,
                                                image: formData["data[enclosure]"],
                                                page: page,
                                                loading: true,
                                                status: formData["data[scheduled_date]"] ? 'scheduled' : 'posted',
                                            }
                                        });
                    
                                        const response = await this.new({
                                            ...formData,
                                            "data[removeDraft]": this.event.originalPost.id,
                                            "data[wait_validation]": JSON.stringify({
                                                name: `${this.currentUser.firstname} ${this.currentUser.lastname}`, 
                                                email: this.currentUser.email,
                                                date: new Date().toISOString()
                                            }), 
                                        });

                                        this.$store.commit('planner/removeStaticEvent', this.event.originalPost.id + page.id)
                                         
                                        if (response.data.success) {
                                            EventBus.$emit('planner/refresh', 0)
                                            this.$emit('close')
                                            onSuccess(formData["data[scheduled_date]"] ? this.$t('dash.posts.drawer.post-scheduled') : this.$t('dash.posts.drawer.post-published'));
                                            return {response, formData: { ...formData, pageId }}
                                        }else{
                                            throw new Error(this.$t('dash.posts.drawer.post-publish-failed'));
                                        }
                                    } catch (error) {
                                        onError(error.message);
                                        return {response:null, formData: { ...formData, pageId }}
                                    }
                                },
                                params : {
                                    picture : formData["data[enclosure]"] || page.avatar,
                                    title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                    loadingText: !formData["data[scheduled_date]"] ? this.$t('dash.post-creator.request.publishing') : this.$t('dash.post-creator.request.scheduling')
                                }
                            });
                        }else{
                            this.$vs.notify({
                                title: this.$t('dash.posts.drawer.validate-impossible'),
                                text: this.$t('dash.posts.drawer.validate-incomplete'),
                                color:'success'
                            })
                            return
                        }
                    }

                    EventBus.$emit('requestManagerAddGroup',requestGroup, async(responses)=> {
                        try {
                            const posts = responses.filter(({response}) => response.data.success && response.data.news && response.data.post && response.data.post.success).map(({response, formData}) => ({
                                _id: response.data.news._id,
                                bot: formData.bot,
                                page: formData.pageId,
                                postId: response.data.post.post,
                                status: 1,
                                story: null,
                            }))
                            console.log("requestManagerAddGroup", posts)
                            if (posts.length > 1) {
                                const res = await this.updatePostsMultiPages(posts)
                            }
                            console.log("requestManagerAddGroup", responses.length , posts.length)
                            if(responses.length == posts.length) {
                                try {
                                    console.log("requestManagerAddGroup", this.event.originalPost.id)
                                    this.deleteDraft(this.event.originalPost.id)
                                } catch (error) {
                                    console.error("Echec de la supression du draft")
                                }
                            }
                        
                        } catch (error) {
                            console.error(error.message)
                        }
                    })     

                }, pagesSelected,  false, false)
            },

            async removeValidationPost(all=null) {
                if (this.isProcessing) return;
                if (this.loading.validation) return

                let countPage = 1
                if (this.officialStatus == "draft")  countPage = this.event.draft.pages.length 
                else if (this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length 
                                                                                        
                if (all == null) {
                 
                    if (countPage > 1) {
                        EventBus.$emit("showModal",
                            this.$t('dash.posts.multi-pages.validate_post.title'),
                            this.$t('dash.posts.multi-pages.remove_validation.body'),
                            this.$t('dash.posts.multi-pages.remove_validation.btn-all'),
                            this.$t('dash.posts.multi-pages.remove_validation.btn-one'),
                            ()=>{
                                this.removeValidationPost(true)
                            },
                            ()=>{
                                this.removeValidationPost(false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }


                this.$set(this.loading, 'validation', true)
                const res = await this.removeValidateWaitingPost(this.event.originalPost, all)
                console.log("removeValidationPost", res)

                this.$set(this.event, 'originalPost', {...this.event.originalPost, ...res.body.post })
                this.$set(this.loading, 'validation', false)
                const newEvent = await this.buildEvent({...this.event.originalPost, ...res.body.post })
                this.$set(this.event, 'status', newEvent.status)
                this.$set(this.event, 'originalStatus', newEvent.originalStatus)
                EventBus.$emit('planner/refresh', 2000)
            },

            setUsersAffected(all = null) {
                if (this.isProcessing) return;
                if (this.loading.setUserAffected) return

                                                                           
                
                let countPage = 1
                if (this.officialStatus == "draft")  countPage = this.event.draft.pages.length 
                else if (this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length 
                      

                if (all == null) {
                 
                    if (countPage > 1) {
                        EventBus.$emit("showModal",
                            this.$t('dash.posts.multi-pages.assign_users.title'),
                            this.$t('dash.posts.multi-pages.assign_users.body'),
                            this.$t('dash.posts.multi-pages.assign_users.btn-all'),
                            this.$t('dash.posts.multi-pages.assign_users.btn-one'),
                            ()=>{
                                this.setUsersAffected(true)
                            },
                            ()=>{
                                this.setUsersAffected(false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }

                this.$set(this.loading , "setUserAffected", true)
             

                const idPagesSelected = this.event.draft.pages
                //Retirer les utilisateurs qui n'ont pas accès à l'ensemble des pages sélectionnées      


                const usersForSelector = Object.fromEntries(
                    Object.entries(this.$store.getters['users/getUsers']).filter(([userId, user]) => 
                        (user.admin && (!user.pages_access || user.pages_access.length == 0)) 
                        || (user.pages_access && user.pages_access.length 
                                && idPagesSelected.every(pageId => user.pages_access.includes(pageId)))
                    )
                );

                const defaultSelection = this.userAffected.map(user => user.id)
                const optionValidation = this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == true || this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == 'true'

                EventBus.$emit('selectUsers',async (idUsersSelected, formCustom)=>{
                    const userChanged = defaultSelection.length != idUsersSelected.length || idUsersSelected.some(id => !defaultSelection.includes(id))

                    const optionValidationChanged = optionValidation != (formCustom?.[0]?.name == "optionValidation" && formCustom[0].value == true)

                    if (userChanged || optionValidationChanged) {
                        this.userAffected = idUsersSelected.map(userId => this.$store.getters['users/getUsers'][userId])

                        const draft = JSON.parse(JSON.stringify(this.event.draft))
                        draft.idUsersAssigned = idUsersSelected
                        draft.requiredValidation =  formCustom?.[0]?.name == "optionValidation"

                        const data = {
                            page: this.event.originalPost._bots[0].page.id, 
                            bot: this.event.originalPost._bots[0].id, 
                            post: this.event.originalPost.id, 
                            status: this.event.originalPost.status,
                            draft : draft,
                            all: all
                        }

                        if (formCustom && formCustom[0] && formCustom[0].name == "optionValidation") {
                            data.optionValidation = formCustom[0].value
                        }

                        if (idUsersSelected.length) {
                            data.user= idUsersSelected[0]
                            data.users= idUsersSelected
                        }
                        console.log("affectedUserToPost", data)
                        await this.affectedUserToPost(data)
                        EventBus.$emit('planner/refresh', 1000)
                    }


                    this.$set(this.loading, "setUserAffected", false)
                  
                    },{

                        
                        users: usersForSelector,
                        defaultSelection,
                        subTitle: this.$t('dash.post-creator.assign.subtitle'),
                        validButtonText: (idUsersAssigned) => {
                            if (idUsersAssigned.length == 0) {
                                return this.$t('dash.post-creator.assign.validate')
                            }
                            if (usersForSelector.length == 0 && idUsersAssigned.length > 0) {
                                return this.$t('dash.select-users.assign')
                            }
                            if (
                                idUsersAssigned.length === this.idUsersAssigned.length &&
                                [...idUsersAssigned].sort().join() === [...usersForSelector].sort().join()
                            ) {
                                return this.$t('dash.select-users.assign')
                            }

                            return this.$t('dash.post-creator.assign.update')

                        },

                        formCustom: [
                            {
                                type: 'checkbox',
                                name: 'optionValidation',
                                label: this.$t('dash.post-creator.assign.required-validation'),
                                value: optionValidation,
                                show: (idUsersAssigned) => idUsersAssigned.length > 0,
                            },
                        ],
                    },()=> {
                            this.$set(this.loading , "setUserAffected", false)
                    }
                )
               
            },
        },

        watch: {
            post: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.buildLogs()
                    this.buildComment()
                    this.buildAssignment()
                }
            },
            ["event.draft.saveAllFormData"]: {
                handler() {
                    this.setFormData()
                },
                immediate: true
            },
        },
        

        computed: {
            officialStatus() {
                return !this.event.originalPost.page || !this.event.originalPost.page.length 
                            ? 'standby' 
                            : ['removed', null, 'scheduled', 'posted', 'pending', 'failed', null, 'draft', "processing"][this.event.originalPost.page[0].status + 1] //+1 pour inclure removed (removed = -1) 
                           
            },
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            usersSortByEmail() {
                return Object.fromEntries(
                    Object.entries(this.$store.getters['users/getUsers']).map(([key, value]) => [value.email, value])
                );
            },
            currentUser() {
                return this.$store.getters['users/getCurrentUser']
            },

            validationStatus() {
                //return null if not option actived or current user not affected
                //return false if post not validated
                //return true if post validated
                if (this.officialStatus == "failed") return null

                if (
                    ['draft', 'scheduled', 'processing'].includes(this.officialStatus) && 
                    this.event.originalPost.page[0].affectedTo &&
                    this.event.originalPost.page[0].affectedTo.optionValidation &&
                    this.event.originalPost.page[0].affectedTo.optionValidation !== "false" &&
                    (
                        (this.event.originalPost.page[0].affectedTo.user && this.event.originalPost.page[0].affectedTo.user.id  == this.currentUser.id) ||
                        (this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                    )

                ) {
                    // option validation actived
                    return ("wait_validation" in this.event.originalPost.page[0] && this.event.originalPost.page[0].wait_validation !== null && this.event.originalPost.page[0].wait_validation !== 'null')

                }


                return null

            },

            canUseActions() {
                return !this.isRefreshingMusic;
            },

            isProcessing() {
                return this.event.originalStatus === 'processing' || this.event.originalPost.page[0]?.posts_multipages?.some((posts_mp) => posts_mp.status === 7);
            },

            optionsContextMenu() {
                const options = [{label: this.$t('dash.posts.drawer.copy-link'), name : 'copyLink'}]

                if (
                    this.event.originalStatus == 'posted' &&
                    ['facebook', 'twitter', 'linkedin', 'pinterest', 'google', 'youtube', 'threads', 'bluesky'].includes(this.event.page.network) &&
                    !(this.event.page.network ===  'linkedin' && !/^[0-9]+$/.test(this.event.originalPost._bots[0].page.network_id)) &&
                    !(this.event.originalPost.page && this.event.originalPost.page[0] && this.event.originalPost.page[0].story)

                ) {
                    options.push({label: this.$t('dash.posts.drawer.view-post'), name : 'showPost'})
                }

                return options
            }

        },

        beforeDestroy() {
            this.$refs.scrollContainer.removeEventListener('wheel', this.handleScroll);
        },
        
    }
</script>